import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
export const ResetTurn = withGame(function ResetTurn({ gameSuite, children, ...rest }) {
    return (_jsx(Button, { onClick: () => gameSuite.prepareTurn(null), disabled: !gameSuite.hasLocalTurn && !gameSuite.turnWasSubmitted, ...rest, children: children || (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "refresh" }), "Reset"] })) }));
});
//# sourceMappingURL=ResetTurn.js.map